import React, { useContext, useState, useCallback } from 'react';
import { FetchCallbacksContext } from '../../internal-components/FetchCallbacks';
import { UPDATE_FORM } from '../../store/modules/state/formBuilder';
import FormBuilderSharePermissionsView from '../view/FormBuilderSharePermissionsView';
import { FormBuilderContext } from './FormBuilderEngine';

const FormBuilderSharePermissionsEngine = () => {
  const { form, autosave, externalUsersLicense } = useContext(FormBuilderContext);
  const { openSnackbar } = useContext(FetchCallbacksContext);

  const [currentPermissions, setCurrentPermissions] = useState({
    internal: form.endUserPermissions && form.endUserPermissions.internal ? form.endUserPermissions.internal : {},
    external: form.endUserPermissions && form.endUserPermissions.external ? form.endUserPermissions.external : {}
  });

  const allowExternalUserAccounts = form.allowExternalUserAccounts;

  const togglePermissions = useCallback(
    (permission, userType, value) => {
      let newCurrentPermissions = {
        ...currentPermissions,
        [userType]: {
          ...(currentPermissions[userType] || {}),
          [permission]: value
        }            
      };
      if (permission === 'allowUsersToInviteExternalPeople' && userType === 'external' && !value) {
        newCurrentPermissions.external.allowEntriesReassignment = false;
      }
      setCurrentPermissions(newCurrentPermissions);
      autosave({
        type: UPDATE_FORM,
        payload: {
          ...form,
          endUserPermissions: {
            ...form.endUserPermissions || {},
            [userType]: {
              ...(form.endUserPermissions ? (form.endUserPermissions[userType] || {}) : {}),
              [permission]: value
            }
          }
        },
        callback: () => {
          openSnackbar('success', 'automation.snackbar.success.general');
        }
      });
    },
    [autosave, currentPermissions]
  );

  const viewProps = {
    allowExternalUserAccounts,
    currentPermissions,
    externalUsersLicense,
    togglePermissions
  };

  return <FormBuilderSharePermissionsView {...viewProps} />;
};

export default FormBuilderSharePermissionsEngine;
